export default "__VITE_PUBLIC_ASSET__2ad8b7d7__"